import { useQueryClient } from '@tanstack/react-query'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/actions/Button'
import StringInput from '../../../../components/inputs/StringInput'
import { ObjectContext } from '../../../../contexts/objectContext/ObjectContext'
import { trpc } from '../../../../modules/trpc'
import PageWrapper from '../../../../wrappers/pageWrapper/PageWrapper'

interface Props {
	onClose?: () => void
}

const SolarPanelSettings: React.FC<Props> = ({ onClose: onCloseProp }) => {
	const { id: objectId, ...object } = useContext(ObjectContext)
	const { t } = useTranslation('pages_enodeInit')
	const queryClient = useQueryClient()
	const utils = trpc.useContext()

	const [maxPower, setMaxPower] = useState<number | undefined | null>(object.panelMaxPower)
	const { mutate: updateMaxPower } = trpc.objects.setMaxPower.useMutation({
		onSuccess: () => {
			utils.user.getObjects.invalidate()
		},
	})

	const handleChange = (value: string) => {
		if (!value) {
			setMaxPower(undefined)
		}
		const numericValue = parseInt(value, 10)
		if (!isNaN(numericValue)) {
			setMaxPower(numericValue)
		}
	}

	const onClose = () => {
		if (maxPower != null) {
			updateMaxPower({ objectId: objectId, maxPower: maxPower })
			queryClient.invalidateQueries('objectOptions' as any)
		}
		onCloseProp?.()
	}

	return (
		<PageWrapper page='solarPanelSettings' appBarOptions={{ navigationType: 'back' }}>
			<div className='text dark:text-white'>{`${t('maxPower.maxTeho')} (Wh)`}</div>

			<div className='container'>
				<StringInput
					onChange={e => handleChange(e)}
					value={maxPower?.toString()}
					label={t('maxPower.maxTeho')}
				/>
			</div>

			<Button onClick={onClose}>{t('tallenna', { ns: 'common' })}</Button>
		</PageWrapper>
	)
}

export default SolarPanelSettings
